<script>
    export let selectedItem; // Receive selectedItem as a prop
    import { onMount } from 'svelte';
  
    let enlargedImage = null; // Track the currently enlarged image
    let isModalOpen = false; // Track whether the modal is open
  
    // Function to open the modal with the enlarged image
    function openModal(file) {
      enlargedImage = `https://pb-105921165.seraphsystems.com/api/files/pbc_3932429598/${file.id}/${file.file}`;
      isModalOpen = true;
    }
  
    // Function to close the modal
    function closeModal() {
      isModalOpen = false;
      enlargedImage = null;
    }
  
    // Close modal when clicking outside the image
    onMount(() => {
      const handleClickOutside = (event) => {
        if (isModalOpen && event.target.classList.contains('modal-backdrop')) {
          closeModal();
        }
      };
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    });
  </script>
  
  <div class="gallery-container">
    {#if selectedItem.egresoFiles && selectedItem.egresoFiles.length > 0}
      {#each selectedItem.egresoFiles.filter(file => file.egresoCab === selectedItem.id) as file}
        <div class="thumbnail" on:click={() => openModal(file)}>
          <img
            src="https://pb-105921165.seraphsystems.com/api/files/pbc_3932429598/{file.id}/{file.file}?thumb=100x100"
            alt={file.file}
            class="thumbnail-image"
          />
          <p class="thumbnail-caption">{file.file}</p>
        </div>
      {/each}
    {:else}
      <p>No hay archivos disponibles.</p>
    {/if}
  </div>
  
  {#if isModalOpen}
    <div class="modal-backdrop">
      <div class="modal-content">
        <button class="close-button" on:click={closeModal}>✕</button>
        <img src={enlargedImage} alt="Enlarged Image" class="enlarged-image" />
      </div>
    </div>
  {/if}
  
  <style>
    .gallery-container {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      padding: 10px;
    }
  
    .thumbnail {
      width: 100px;
      text-align: center;
      cursor: pointer; /* Indicate that the thumbnail is clickable */
    }
  
    .thumbnail-image {
      width: 100%;
      height: auto;
      border-radius: 5px;
    }
  
    .thumbnail-caption {
      margin-top: 5px;
      font-size: 0.8em;
      color: #666;
    }
  
    .modal-backdrop {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.8); /* Semi-transparent black background */
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1000; /* Ensure the modal is on top */
    }
  
    .modal-content {
      position: relative;
      background-color: white;
      padding: 20px;
      border-radius: 10px;
      max-width: 90%;
      max-height: 90%;
      overflow: auto;
    }
  
    .close-button {
      position: absolute;
      top: 10px;
      right: 10px;
      background: none;
      border: none;
      font-size: 1.5em;
      cursor: pointer;
      color: #333;
    }
  
    .enlarged-image {
      max-width: 100%;
      max-height: 80vh; /* Limit the height to 80% of the viewport height */
      border-radius: 5px;
    }
  </style>